import {Injectable} from "@angular/core";
import { Data } from "@angular/router";
import {DataResponse, ListDataResponse} from "src/app/models/http.models";
import {Observable, Observer, Subject} from "rxjs";
import {BaseApiService} from "./_baseApiService";
import {ConfirmEmailViewModel, RegistrationRequest} from "../../models/registrazione.models";

@Injectable({ providedIn: 'root'})

export class RegistrationService extends BaseApiService{

// Non so come utilizzare le liste.

  // public searchCompanies():Observer<<>>{
  //     return this.httpService.getList();
  // }

  /*public getCompanyDetail(companyId: number):Observable<DataResponse<Company>>{
    return this.httpService.get(`api/v1/companies/${companyId}`);
  }*/
  public newCandidateRegistration(form: FormData):Observable<DataResponse<Response>>{
    return this.httpService.postFile(`PortalsAuth/SignUp`, form);
  }

  public resendConfirmationEmail(email : string):Observable<DataResponse<Response>>{
    return this.httpService.post(`PortalsAuth/ResendConfirmEmail?email=`+email);
  }

  public confirmEmail(model : ConfirmEmailViewModel ):Observable<DataResponse<Response>>{
    return this.httpService.post(`PortalsAuth/ConfirmEmail`,model);
  }

  public registrationCompleted$ = new Subject<any>();

}
